<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_1">Partners in Crime</a></h1><a id="page_1">
<h1 class="subtitle">A Tommy and Tuppence Collection</h1>
<p class="author">Agatha Christie</p>
<div class="img_container">
<img alt="images" src="images/logo3.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?09ed36b2